import type { Router, RouteRecordRaw } from 'vue-router'
import { usePermissionsStore } from 'modules/login/model/permissions.store'
import { PageName } from 'shared/lib/types/app/pages'

export const moduleRoute: RouteRecordRaw = {
  path: 'admin-panel',
  name: PageName.ADMIN_PANEL,
  component: () => import('./pages/AdminPanelIndex.vue'),
  beforeEnter: () => usePermissionsStore().showAdminPanel || { name: PageName.ERROR_403 },
  meta: {
    breadcrumbName: 'Админ-панель',
    breadcrumbOnly: true,
  },
}

export default (router: Router) => {
  router.addRoute(PageName.MAIN_LAYOUT, moduleRoute)
}
